import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import PrimeVue from 'primevue/config'
import i18n, { useRTL } from './i18n'

// PrimeVue Components
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Toast from 'primevue/toast'
import ToastService from 'primevue/toastservice'
import ConfirmDialog from 'primevue/confirmdialog'
import ConfirmationService from 'primevue/confirmationservice'
import Dropdown from 'primevue/dropdown'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from 'primevue/dialog'
import Card from 'primevue/card'
import IconField from 'primevue/iconfield'
import InputIcon from 'primevue/inputicon'
import Paginator from 'primevue/paginator'
import Tooltip from 'primevue/tooltip'
import Calendar from 'primevue/calendar'
import Textarea from 'primevue/textarea'
import FileUpload from 'primevue/fileupload'
import Tag from 'primevue/tag'
import TreeTable from 'primevue/treetable'
import Checkbox from 'primevue/checkbox'
import Panel from 'primevue/panel'

// Styles
import 'primevue/resources/themes/lara-light-green/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'
import 'primeflex/primeflex.css'
import './styles/rtl.css'

// Font Awesome
import { setupFontAwesome } from './plugins/fontawesome'

const app = createApp(App)

// Use plugins
app.use(router)
app.use(store)
app.use(ConfirmationService)
app.use(ToastService)
setupFontAwesome(app)

app.use(PrimeVue, {
  ripple: true,
  inputStyle: 'filled',
  zIndex: {
    modal: 1100,
    overlay: 1000,
    menu: 1000,
    tooltip: 1100,
    toast: 1200
  },
  locale: {
    startsWith: 'يبدأ بـ',
    contains: 'يحتوي على',
    notContains: 'لا يحتوي على',
    endsWith: 'ينتهي بـ',
    equals: 'يساوي',
    notEquals: 'لا يساوي',
    noFilter: 'بدون فلتر',
    lt: 'أقل من',
    lte: 'أقل من أو يساوي',
    gt: 'أكبر من',
    gte: 'أكبر من أو يساوي',
    dateIs: 'التاريخ هو',
    dateIsNot: 'التاريخ ليس',
    dateBefore: 'التاريخ قبل',
    dateAfter: 'التاريخ بعد',
    clear: 'مسح',
    apply: 'تطبيق',
    matchAll: 'مطابقة الكل',
    matchAny: 'مطابقة أي',
    addRule: 'إضافة قاعدة',
    removeRule: 'حذف قاعدة',
    accept: 'نعم',
    reject: 'لا',
    choose: 'اختر',
    upload: 'رفع',
    cancel: 'إلغاء',
    dayNames: ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
    dayNamesShort: ['أحد', 'إثن', 'ثلا', 'أرب', 'خمي', 'جمع', 'سبت'],
    dayNamesMin: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
    monthNames: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'],
    monthNamesShort: ['ينا', 'فبر', 'مار', 'أبر', 'ماي', 'يون', 'يول', 'أغس', 'سبت', 'أكت', 'نوف', 'ديس'],
    today: 'اليوم',
    weekHeader: 'الأسبوع',
    firstDayOfWeek: 6,
    dateFormat: 'dd/mm/yy',
    weak: 'ضعيف',
    medium: 'متوسط',
    strong: 'قوي',
    passwordPrompt: 'أدخل كلمة المرور',
    emptyFilterMessage: 'لا توجد نتائج',
    emptyMessage: 'لا توجد خيارات متاحة'
  }
})
app.use(i18n)

// Register PrimeVue components
app.component('Button', Button)
app.component('InputText', InputText)
app.component('Toast', Toast)
app.component('ConfirmDialog', ConfirmDialog)
app.component('Dropdown', Dropdown)
app.component('DataTable', DataTable)
app.component('Column', Column)
app.component('Dialog', Dialog)
app.component('Card', Card)
app.component('IconField', IconField)
app.component('InputIcon', InputIcon)
app.component('Paginator', Paginator)
app.component('Calendar', Calendar)
app.component('Textarea', Textarea)
app.component('FileUpload', FileUpload)
app.component('Tag', Tag)
app.component('TreeTable', TreeTable)
app.component('Checkbox', Checkbox)
app.component('Panel', Panel)

// Register directives
app.directive('tooltip', Tooltip)

app.mount('#app')
